<template>
  <div>
    <v-btn
      fab
      bottom
      right
      color="pink"
      dark
      fixed
      @click.stop="dialog = !dialog"
    >
      <v-icon>add</v-icon>
    </v-btn>
    <v-dialog v-model="dialog" width="800px">
        <v-card>
          <v-card-title
            class="grey lighten-4 py-4 title"
          >
            Add Client
          </v-card-title>
          <v-card-text>
            <dfs-client-add-form @namechanged="onNameChanged"></dfs-client-add-form>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click="saveNew">Save</v-btn>
            <v-btn flat @click="dialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <AppMainDialog :open="dialogOpen" :message="dialogMessage" @closedialog="dialogOpen = false"></AppMainDialog>
  </div>
</template>

<script>
  import AppMainDialog from '@/components/AppMainDialog'
  import AddButtonMixins from '@/mixins/AddButton'
  import dfsClientAddForm from '@/components/ClientAddForm'
  import CrudAPI from '@/api/resources/crud'

  export default {
    components: { AppMainDialog, dfsClientAddForm },
    mixins: [ AddButtonMixins ],
    data () {
      return {
        resources: 'clients',
        dialog: false,
        dialogMessage: '',
        dialogOpen: false,
        modelName: ''
      }
    },
    methods: {
      saveNew () {
        let payload = {
          name: this.modelName
        }

        let result = CrudAPI.dfsResourceStore(this.resources, payload)

        result.then(this.saveNewSuccess, this.saveNewError)
      },
      onNameChanged (newVal) {
        this.modelName = newVal
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AddClientButton.vue?1079d133